import PropTypes from "prop-types";
import React from "react";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";

const SelectionGroup = props => {
  const { input, containerClassName, meta, ...rest } = props;
  delete rest.meta;
  delete rest.input;
  delete rest.containerClassName;
  delete rest.error;
  delete rest.errorText;

  const inError = meta.touched && meta.invalid;
  return (
    <div>
      <RadioGroup
        className={containerClassName}
        {...rest}
        value={input.value}
        onChange={(e) => input.onChange(e.target.value)}
      >
        {rest.controls && rest.controls.map((control, index) => (
          <FormControlLabel
            key={index}
            value={control.value}
            control={<Radio />}
            label={control.label}
          />
        ))}
      </RadioGroup>
      <div className="validation-error" style={{marginLeft: "7%"}}>
          {
            inError &&
            meta.error
          }
      </div>      
    </div>
    );
};

SelectionGroup.propTypes = {
  input: PropTypes.object.isRequired,
  containerClassName: PropTypes.string,
  meta: PropTypes.object.isRequired,
};
export default SelectionGroup;